'use client';

import React from 'react';
import {
  IconName,
  IconPrefix,
  SizeProp,
} from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProps } from '../../common/interfaces';

export const Icon: React.FC<IconProps> = ({ prefix, icon, size, spin = false }) => {
  return (
    <FontAwesomeIcon
      icon={[prefix as IconPrefix, icon as IconName]}
      size={size as SizeProp}
      spin={spin}
    />
  );
};
